'use strict';
const _ = require('lodash');
const Backbone = require('backbone');
const PubSub = require('../PubSub');
const template = require('../templates/category-submit.ejs');

module.exports = Backbone.View.extend({
    tagName: 'div',
    className: 'view-submit',
    events: {
        'click .btn-submit': 'submitVotes'
    },
    /**
     * Initialize view
     */
    initialize: function (options) {
        _.bindAll(this, 'render');
        this.voteLimit = options.voteLimit;
        this.votesRemaining = options.votesRemaining;
        this.isSubmitDisabled = !this.model.get('totalAllocatedVotes');
        this.listenTo(this.model, 'change:totalAllocatedVotes', this.handleVoteAllocationChange.bind(this));
    },
    /**
     * Render category submit
     */
    render: function () {
        this.$el.html(template({
            id: this.model.get('id'),
            voteLimit: this.voteLimit,
            isSubmitDisabled: !this.model.get('totalAllocatedVotes'),
            votesRemaining: this.votesRemaining
        }));
        return this;
    },

    handleVoteAllocationChange: function(){
        if(this.isSubmitDisabled === !!this.model.get('totalAllocatedVotes')){
            this.isSubmitDisabled = !this.model.get("totalAllocatedVotes");
            PubSub.trigger('vote-allocation-change', this.isSubmitDisabled);
            this.render();
        }
    },
    /**
     * Submit votes for the category
     */
    submitVotes: function(e) {
        e.preventDefault();
        if(!this.model.get('totalAllocatedVotes')) {
            return false;
        }

        e.currentTarget.setAttribute('disabled', 'disabled');

        var data = {
            categoryID: this.model.get('id'),
            categoryName: this.model.get('name'),
            categoryVoteData: this.model.get('categoryVotes'),
            totalAllocatedVotes: this.model.get('totalAllocatedVotes')
        };
        PubSub.trigger('submitVotes', data);
    }
});



// WEBPACK FOOTER //
// ./app/scripts/views/category-submit.js